var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"mx-2",attrs:{"outlined":"","small":"","color":"info"},on:{"click":function($event){return _vm.$router.push(_vm.to || _vm.lastRoute)}}},[_c('v-icon',{attrs:{"dark":"","small":""}},[_vm._v(" mdi-arrow-left ")]),_vm._v(" Back ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }